import { filesDataSourceV3 } from '../../api/files';

export function getFileName(eventid, fileUrl): Promise<any> {
    const ds = filesDataSourceV3(eventid);
    // const exprtmp = [{
    //     name: 'file',
    //     op: 'eq',
    //     val: fileUrl
    // }] as Entities.Expression[];

    // expr = convertFromOldFormat(exprtmp);
    return ds
        .query({
            filters: {
                $meta: {
                    path: "url",
                    $token: {
                        file: {
                            $equal: fileUrl
                        }
                    }
                }
            },
            selects: {
                $all: true,
                file: true
            },
        }, ["file"])
        .then((file) => {
            if (file && file.data && file.data.length) {
                return Promise.resolve(file.data[0].title);
            }
            return Promise.reject("File not found");
        }, (err) => {
            return Promise.reject(err);
        });
}
